import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

const styles = require('./TeamDetails-styles.css');

const TeamDetails = ({ data, activeTeam }) => {
  const team = useMemo(() => data[0].qNodes.find((node) => node.qText === activeTeam), [data, activeTeam]);
  const editions = [...team.qNodes].sort((a, b) => Number(a.qText) - Number(b.qText));
  return (
    <div className={styles.teamDetails}>
      <div className={styles.teamDetailsContent}>
        <div className={styles.sectionKPIs}>
          <div className={styles.heading}>
            <div className={styles.flag}>
              <img src={`assets/flags/${team.qText}.png`} alt={`Flag of ${team.qText}`} />
            </div>
            <div className={styles.name}>{team.qText}</div>
          </div>
          <div className={styles.values}>
            <div className={styles.valuesRow}>
              <div className={styles.featuredValue}>
                <div className={styles.label}>WIN RATE</div>
                <div className={styles.number}>
                  {Math.round((team.qValues[6].qValue / team.qValues[5].qValue) * 100)}
                  &#x25;
                </div>
              </div>
              <div className={styles.value}>
                <div className={styles.label}>GAMES PLAYED</div>
                <div className={styles.number}>{team.qValues[5].qValue}</div>
              </div>
              <div className={styles.value}>
                <div className={styles.label}>WINS</div>
                <div className={styles.number}>{team.qValues[6].qValue}</div>
              </div>
              {/* <div className={styles.value}>
                <div className={styles.label}>DRAWS</div>
                <div className={styles.number}>{team.qValues[8].qValue}</div>
              </div> */}
              <div className={styles.value}>
                <div className={styles.label}>LOSSES</div>
                <div className={styles.number}>{team.qValues[7].qValue}</div>
              </div>
              <div className={styles.value} />
            </div>
            <div className={styles.valuesRow}>
              <div className={styles.featuredValue}>
                <div className={styles.label}>POINTS SCORED</div>
                <div className={styles.number}>{team.qValues[0].qValue}</div>
              </div>
              <div className={styles.value}>
                <div className={styles.label}>TRIES</div>
                <div className={styles.number}>{team.qValues[1].qValue}</div>
              </div>
              <div className={styles.value}>
                <div className={styles.label}>CONVERSIONS</div>
                <div className={styles.number}>{team.qValues[2].qValue}</div>
              </div>
              <div className={styles.value}>
                <div className={styles.label}>PENALTIES</div>
                <div className={styles.number}>{team.qValues[3].qValue}</div>
              </div>
              <div className={styles.value}>
                <div className={styles.label}>DROP GOALS</div>
                <div className={styles.number}>{team.qValues[4].qValue}</div>
              </div>
            </div>
            <div className={classnames(styles.valuesRow, styles.perValues)}>
              <div className={styles.featuredValue}>
                <div className={styles.label}>SCORE A POINT EVERY</div>
                <div className={styles.number}>
                  {team.qValues[0].qValue ? (team.qValues[9].qValue / team.qValues[0].qValue).toFixed(2) : '-'}
                  &nbsp;
                  <span className={styles.unit}>MINUTES</span>
                </div>
              </div>
              <div className={styles.value}>
                <div className={styles.label}>A TRY EVERY</div>
                <div className={styles.number}>
                  {team.qValues[1].qValue ? (team.qValues[9].qValue / team.qValues[1].qValue).toFixed(2) : '-'}
                  &nbsp;
                  <span className={styles.unit}>MIN</span>
                </div>
              </div>
              <div className={styles.value}>
                <div className={styles.label}>A CONVERSION EVERY</div>
                <div className={styles.number}>
                  {team.qValues[2].qValue ? (team.qValues[9].qValue / team.qValues[2].qValue).toFixed(2) : '-'}
                  &nbsp;
                  <span className={styles.unit}>MIN</span>
                </div>
              </div>
              <div className={styles.value}>
                <div className={styles.label}>A PENALTY EVERY</div>
                <div className={styles.number}>
                  {team.qValues[3].qValue ? (team.qValues[9].qValue / team.qValues[3].qValue).toFixed(2) : '-'}
                  &nbsp;
                  <span className={styles.unit}>MIN</span>
                </div>
              </div>
              <div className={styles.value}>
                <div className={styles.label}>A DROP GOAL EVERY</div>
                <div className={styles.number}>
                  {team.qValues[4].qValue ? (team.qValues[9].qValue / team.qValues[4].qValue).toFixed(0) : '-'}
                  &nbsp;
                  <span className={styles.unit}>MIN</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.sectionChart}>
          <div className={styles.chartTitle}>HISTORICAL PERFORMANCE</div>
          <div className={styles.chart}>
            {['1987', '1991', '1995', '1999', '2003', '2007', '2011', '2015', '2019'].map((year) => {
              const edition = editions.find((e) => e.qText === year);
              return (
                <div key={year} className={styles.chartCol}>
                  <div className={classnames(
                    (edition && edition.qAttrDims.qValues[0].qText === '1') && styles.spacer1,
                    (edition && edition.qAttrDims.qValues[0].qText === '2') && styles.spacer2,
                    (edition && edition.qAttrDims.qValues[0].qText === '3') && styles.spacer3,
                    (edition && edition.qAttrDims.qValues[0].qText === '4') && styles.spacer4,
                    (edition && edition.qAttrDims.qValues[0].qText === 'Pool') && styles.spacerPool,
                    !edition && styles.spacerNone,
                  )}
                  />
                  <div className={styles.chartColVal}>{!!edition && edition.qAttrDims.qValues[0].qText}</div>
                  <div className={styles.chartColLine} />
                  <div className={styles.chartColLabel}>{year}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

TeamDetails.propTypes = {
  data: PropTypes.array,
  activeTeam: PropTypes.string,
};
TeamDetails.defaultProps = {
  data: null,
  activeTeam: null,
};

export default TeamDetails;
